
import { Button } from "element-ui";
export default {
  components: {
    Button,
  },
};
